import { MButton } from '@Components/Base';

import { ReactComponent as EyeIcon } from '@Icons/additional/eye-gradient.svg';

import styles from './panel-header.module.css';

interface PanelHeaderProps {
  title: string;
  description: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

const PanelHeader: React.FC<PanelHeaderProps> = ({
  onClick,
  title,
  description,
}) => {
  return (
    <>
      <MButton className={styles.title} type="text" onClick={onClick}>
        {title} <EyeIcon />
      </MButton>
      <span className={styles.description}>{description}</span>
    </>
  );
};

export default PanelHeader;
